"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _interopRequireWildcard = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.install = exports.default = void 0;
Object.defineProperty(exports, "version", {
  enumerable: true,
  get: function () {
    return _package.version;
  }
});
var areaTree = _interopRequireWildcard(require("./lib/area-tree"));
var _crypto = _interopRequireDefault(require("./lib/crypto"));
var date = _interopRequireWildcard(require("./lib/date"));
var debounce = _interopRequireWildcard(require("./lib/debounce"));
var dict = _interopRequireWildcard(require("./lib/dict"));
var file = _interopRequireWildcard(require("./lib/file"));
var functions = _interopRequireWildcard(require("./lib/functions"));
var _http = _interopRequireDefault(require("./lib/http"));
var num = _interopRequireWildcard(require("./lib/num"));
var test = _interopRequireWildcard(require("./lib/test"));
var throttle = _interopRequireWildcard(require("./lib/throttle"));
var tree = _interopRequireWildcard(require("./lib/tree"));
var isPolling = _interopRequireWildcard(require("./lib/usePolling"));
var _package = require("./package.json");
/*
 * @Description: 工具方法：这里写项目常用的工具函数，其他的可以使用lodash
 * lodash文档 https://lodash.com/docs/4.17.15
 * @Author: yitong
 * @Date: 2021-10-11 14:33:08
 * @LastEditors: yitong
 * @LastEditTime: 2022-06-30 18:10:45
 */

const $m = {
  v: _package.version,
  version: _package.version,
  ...debounce,
  ...functions,
  ...throttle,
  crypto: _crypto.default,
  date,
  file,
  test,
  http: _http.default,
  get: _http.default.get,
  post: _http.default.post,
  put: _http.default.put,
  delete: _http.default.delete,
  tree,
  num,
  ...areaTree,
  ...dict,
  ...isPolling
};
const install = Vue => {
  Vue.prototype.$m = $m;
};
exports.install = install;
var _default = exports.default = {
  version: _package.version,
  install
};